import React from 'react'
import Icon from '../misc/Icons'
import HelpDrawerWrapper from './HelpDrawerWrapper'
import KeyboardShortcutHelpDrawer from './KeyboardShortcutHelpDrawer'


class SetEditorHelpDrawers extends React.Component{

	constructor(){
		super()
		this.closeAssistantDrawer=this.closeAssistantDrawer.bind(this)
		this.closeKeyboardShortcutDrawer=this.closeKeyboardShortcutDrawer.bind(this)
		
		this.state={
	   	showKeyboardShortcut:false,
	   	showAssistant:false,
		}
	}

	closeAssistantDrawer(){
		this.setState({
			showAssistant: false
		})
	}

	closeKeyboardShortcutDrawer(){
		this.setState({
			showKeyboardShortcut: false
		})
	}

	render(){		
			
		return(

			<React.Fragment>

				<div className='helpDrawers-launchPanel' key='launchPanel'>								
					<div className='helpDrawers-launchPanel-keyboardBtn' onClick={()=>{this.setState({showKeyboardShortcut:true})}} >						
						<Icon name='keyboard' />
					</div>
				</div>

				<HelpDrawerWrapper drawerType={'keyboard'} showDrawer={this.state.showKeyboardShortcut} key='keyboard'>
					<KeyboardShortcutHelpDrawer isViewOnly={this.props.isViewOnly} closeKeyboardShortcutDrawer={this.closeKeyboardShortcutDrawer} /> 
				</HelpDrawerWrapper>

			</React.Fragment>		
		)
	}
}

export default SetEditorHelpDrawers

